import commonService from './common-service';

class RegionService {
  async getRegions() {
    try {
      const response = await commonService.getFromServer('Regions', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
}

export default new RegionService();
